import { connect } from 'react-redux';
import { streamActions, mediaSelectors } from '@lifesize/nucleus';
import actions from 'actions/AvSettingsModal';
import SourceDisplay from 'components/SourceDisplay/AvSourceDisplay';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const videoDevices = mediaSelectors.videoDevices(state) || [];
  const audioDevices = mediaSelectors.audioDevices(state) || [];
  const audioOutputDevices = mediaSelectors.audioOutputDevices(state) || [];
  const savedVideoId = _get(state, 'app.avSettings.videoSourceId');
  const savedAudioId = _get(state, 'app.avSettings.audioSourceId');
  const savedAudioOutputId = _get(state, 'app.avSettings.audioOutputId');
  let savedVideoDevice;
  let savedAudioDevice;
  let savedOutputDevice;

  if (savedVideoId) {
    savedVideoDevice = videoDevices.find(
      device => (device.deviceId === savedVideoId));
  }

  if (savedAudioId) {
    savedAudioDevice = audioDevices.find(
      device => (device.deviceId === savedAudioId));
  }

  if (savedAudioOutputId) {
    savedOutputDevice = audioOutputDevices.find(
      device => (device.deviceId === savedAudioOutputId));
  }

  const selectedVideoSource = savedVideoDevice || mediaSelectors.selectedVideoDevice(state);
  const selectedAudioSource = savedAudioDevice || mediaSelectors.selectedAudioDevice(state);
  const selectedAudioOutputDevice =
    savedOutputDevice || mediaSelectors.selectedAudioOutputDevice(state);
  const primaryVideoSourceId = _get(selectedVideoSource, 'deviceId');
  const primaryAudioSourceId = _get(selectedAudioSource, 'deviceId');

  const defaultVideoSetting = typeof ownProps.defaultVideoSetting === 'boolean' ? ownProps.defaultVideoSetting : true;
  const defaultAudioSetting = _get(state, 'app.avSettings.audio');

  const selectedSources = {
    primaryVideoSourceId,
    primaryAudioSourceId
  };

  let selectedVideoLabel = selectedVideoSource ? selectedVideoSource.label : null;
  if (!selectedVideoLabel) {
    selectedVideoLabel = videoDevices.length ? videoDevices[0].label : '';
  }

  let selectedAudioLabel = selectedAudioSource ? selectedAudioSource.label : null;
  if (!selectedAudioLabel) {
    selectedAudioLabel = audioDevices.length ? audioDevices[0].label : '';
  }

  let selectedAudioOutputLabel = selectedAudioOutputDevice ? selectedAudioOutputDevice.label : null;
  const selectedAudioOutputId =
    selectedAudioOutputDevice ? selectedAudioOutputDevice.deviceId : null;

  if (!selectedAudioOutputLabel) {
    selectedAudioOutputLabel = audioOutputDevices.length ? audioOutputDevices[0].label : '';
  }

  return {
    videoDevices,
    audioDevices,
    selectedSources,
    selectedVideoLabel,
    selectedAudioLabel,
    selectedAudioOutputLabel,
    selectedAudioOutputId,
    defaultVideoSetting,
    defaultAudioSetting,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  acquireLocalPrimaryStream: () => {
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true }));
  },
  endLocalStream: () => dispatch(streamActions.endLocalStream()),
  selectVideoSource: (id, sources) => {
    dispatch(actions.selectNextCallVideoSource(id));
    dispatch(streamActions.setSelectedVideoSourceId(id));
    const videoSetting = typeof ownProps.defaultVideoSetting === 'boolean' ? ownProps.defaultVideoSetting : true;
    const audioSetting = typeof ownProps.defaultAudioSetting === 'boolean' ? ownProps.defaultAudioSetting : true;
    const setSources = Object.assign(
      {}, sources, { audio: audioSetting, video: videoSetting }, { primaryVideoSourceId: id }
    );
    dispatch(streamActions.acquireLocalPrimaryStream(setSources));
  },
  selectAudioSource: (id, sources) => {
    dispatch(actions.selectNextCallAudioSource(id));
    dispatch(streamActions.setSelectedAudioSourceId(id));
    const videoSetting = typeof ownProps.defaultVideoSetting === 'boolean' ? ownProps.defaultVideoSetting : true;
    const audioSetting = typeof ownProps.defaultAudioSetting === 'boolean' ? ownProps.defaultAudioSetting : true;
    const setSources = Object.assign(
      {}, sources, { audio: audioSetting, video: videoSetting }, { primaryAudioSourceId: id }
    );
    dispatch(streamActions.acquireLocalPrimaryStream(setSources));
  },
  selectAudioOutput: (id) => {
    dispatch(actions.setNextCallOutput(id));
  },
  toggleAudioMuteSetting: (toggle) => { dispatch(actions.toggleNextCallAudio(toggle)); }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  Object.assign({}, ownProps, stateProps, dispatchProps,
    {
      selectVideoSource: (id, sources) =>
        dispatchProps.selectVideoSource(id, Object.assign({}, stateProps.selectedSources, sources)),
      selectAudioSource: (id, sources) =>
        dispatchProps.selectAudioSource(id, Object.assign({}, stateProps.selectedSources, sources))
    },
    {
      acquireLocalPrimaryStream: () => dispatchProps.acquireLocalPrimaryStream(stateProps.browser)
    })
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SourceDisplay);
